<span *ngIf="!secondsOnly" class="timeFormat">{{ hours }}:{{ minutes }}:{{ seconds }}</span>
<span *ngIf="secondsOnly" class="timeFormat">{{ seconds }}s</span>